import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=348dc56d"
import script from "./ArticleTable.vue?vue&type=script&lang=js"
export * from "./ArticleTable.vue?vue&type=script&lang=js"
import style0 from "./ArticleTable.vue?vue&type=style&index=0&id=348dc56d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports